import React, { useEffect, useRef } from "react";
import "./Home.scss";
import ProgressBar from "../../Components/ProgressBar/ProgressBar";
import { Link } from "react-router-dom";
// import ContactForm from "../../Components/Forms/Contact/Contact";

const Home = () => {
  const waveIconRef = useRef(null); // Ref for the wave icon
  const padlockRef = useRef(null); // Ref for the padlock

  useEffect(() => {
    const waveIcon = waveIconRef.current?.querySelectorAll(".arc");
    const padlockShackle =
      padlockRef.current?.querySelectorAll(".padlock-shackle");

    // Function to handle animations for elements when they come into view
    const handleAnimation = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // For the wave icon
          if (entry.target.classList.contains("arc")) {
            const arc = entry.target;
            arc.classList.add("animate-wave");
          }

          // For the padlock
          if (entry.target.classList.contains("padlock-shackle")) {
            const shackle = entry.target;
            shackle.classList.add("animate-shackle");
          }
        } else {
          // Reset the wave animation when out of view
          if (entry.target.classList.contains("arc")) {
            const arc = entry.target;
            arc.classList.remove("animate-wave");
            void arc.offsetWidth; // Force reflow to reset animation
          }

          // Reset the padlock animation when out of view
          if (entry.target.classList.contains("padlock-shackle")) {
            const shackle = entry.target;
            shackle.classList.remove("animate-shackle");
            void shackle.offsetWidth; // Force reflow to reset animation
          }
        }
      });
    };

    // Create IntersectionObserver instances for both wave and padlock
    const observer = new IntersectionObserver(handleAnimation, {
      threshold: 0.1, // Trigger when 10% of the element is visible
    });

    // Observe wave icon arcs
    waveIcon?.forEach((arc) => {
      if (arc instanceof Element) {
        observer.observe(arc);
      }
    });

    // Observe padlock shackles
    padlockShackle?.forEach((shackle) => {
      if (shackle instanceof Element) {
        observer.observe(shackle);
      }
    });

    // Cleanup observer on component unmount
    return () => {
      waveIcon?.forEach((arc) => {
        if (arc instanceof Element) {
          observer.unobserve(arc);
        }
      });
      padlockShackle?.forEach((shackle) => {
        if (shackle instanceof Element) {
          observer.unobserve(shackle);
        }
      });
    };
  }, []);

  return (
    <div className="home">
      <div className="container section section1">
        <h1>
          Shake up your brand and give it that '<span className="oo">OO</span>
          <span className="after-oo"> ' </span>
          factor.
        </h1>
        <p className="text-under-heading">
          Boost your brand’s potential with the best progressive web application
          technology and design.
        </p>
      </div>

      <div className="container section section2">
        <div className="section-block">
          <h2>
            Increase your website's Google search rankings with unparalleled
            speed and performance.
          </h2>
        </div>
        <div className="section-block">
          <ProgressBar />
        </div>
      </div>

      <div className="container section section3">
        <div className="section-block">
          <div ref={waveIconRef} className="wave-icon">
            <div className="arc arc1"></div>
            <div className="arc arc2"></div>
            <div className="arc arc3"></div>
            <div className="line"></div>
          </div>
        </div>
        <div className="section-block">
          <h2>
            Your web app will be downloadable as an application for your phone,
            tablet or desktop.
          </h2>
        </div>
      </div>

      <div className="container section section4">
        <div className="section-block">
          <h2>
            Fully managed hosting, SSL certification and custom user-friendly
            content management systems make creating content easy.
          </h2>
        </div>
        <div className="section-block padlock-block" ref={padlockRef}>
          <div className="padlock">
            <div className="padlock-body"></div>
            <div className="padlock-shackle"></div>
            <div className="padlock-keyhole"></div>
            <div className="padlock-shackle cover"></div>
          </div>
        </div>
      </div>

      <div className="container section section3">
        <div className="section-block">
          <div class="graph-container">
            <div class="graph">
              <div class="arrow">
                <div class="arrow-head"></div>
                <div class="arrow-base"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="section-block">
          <h2>
            Website traffic analysis with data driven AI suggestions to help you
            continously reach a wider audience.
          </h2>
        </div>
      </div>

      <div className="container section-bottom">
        <h2>Get in touch.</h2>
        <p className="text-under-heading">
          Whether you have an existing website or are looking to create a new
          one, contact us using our simple contact form{" "}
          <Link to="/contact" className="contact-link">
            here.
          </Link>
        </p>
        <ul>
          <li>Performance enhancing progressive web application technology.</li>
          <li>
            Your website will become downloadable as an app for mobile, tablet
            and desktop.
          </li>
          <li>
            Access to a user-friendly interface allowing you to easily edit, add
            or delete pages of your website.
          </li>
          <li>
            Website design services to create a responsive and visually engaging
            user experience with brand recognition.
          </li>
          <li>
            Built in AI technology for website traffic analysis and page
            creation, focused on growing your website's visitors.
          </li>
        </ul>
        <Link to="/contact" className="contact-btn">
          Contact
        </Link>
      </div>
    </div>
  );
};

export default Home;
